module.exports = __webpack_public_path__ + "static/media/rhd_2.1bec65de.png";